/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { claimService } from "../../../../api/services/claimService";
import {
  setAllClaimList,
  setAllClaimListLoader,
} from "../../../../infra/aggregates/myProfile/claimAggregates/claimListSlice";

interface PropsValues {
  setEmpClaimData: (data: any) => void;
}

function DTOClaimList({ setEmpClaimData }: PropsValues) {
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state.authSlice);
  const storeClaimList = useAppSelector(
    (state) => state.claimListSlice.claimList
  );
  async function getEmpClaims(empId: number, companyId: number) {
    dispatch(setAllClaimListLoader(true));
    const response = await claimService.getAllEmployeeClaims(empId, companyId);
    if (response) {
      dispatch(setAllClaimList(response?.data));
      setEmpClaimData(response?.data);
      dispatch(setAllClaimListLoader(false));
    } else {
      dispatch(setAllClaimListLoader(false));

      return;
    }
  }
  useEffect(() => {
    if (selector) getEmpClaims(selector.emp_id, selector.company_id);
  }, []);

  useEffect(() => {
    setEmpClaimData(storeClaimList);
  }, [storeClaimList]);

  return <></>;
}
export default DTOClaimList;
